import classNames from 'classnames';
import classes from 'components/generics/fields/TextField/index.module.scss';

interface Props {
  text: string;
  isError?: boolean;
}

const HelperText = ({ text, isError }: Props) => {
  return (
    <div
      className={classNames(classes.helperText, { [classes.error]: isError })}
    >
      {text}
    </div>
  );
};

export default HelperText;
